import { GET_MEDICAL_CERTIFICATES_BY_PATIENT } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    data?: ResponseEntity[];
}
export interface ResponseEntity {
    id: string;
    url: string;
    name: string;
    created_at: string;
}

export default (ptId: string): Promise<Response> =>
    fetchWithRefresh(GET_MEDICAL_CERTIFICATES_BY_PATIENT(ptId), {
        mode: 'cors',
        credentials: 'include',
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('can not fetch medical certificates for patient');
        }
    });
